import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import styles from "../commanstyles.module.css";
import FinancialDocuments from "./FinancialDocuments";
import ChargeDocuments from "./ChargeDocuments";
import IncorporationandOtherDocuments from "./IncorporationandOtherDocuments";
import ScannedDocuments from "./ScannedDocuments";
import { referenceDocument } from "../../../Services/APIrequests";
import { RotatingLines } from "react-loader-spinner";

function SourceDocuments({ isSubScribe,refreshLoading }) {
  const financialData = [
    { title: "Incorporation and Other Documents", type: "Incorporation" },
    { title: "Charge Documents", type: "Charge" },
    { title: "Financial Documents", type: "Financial" },
    { title: "Scanned Documents", type: "Scanned" },
  ];

  const { cin } = useParams();
  const [activeTab, setActiveTab] = useState(financialData[0].type);
  const [documentData, setDocumentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDocuments = useCallback(async (documentCategory) => {
    if (!cin) {
      setError("CIN is required to fetch documents.");
      setDocumentData([]);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await referenceDocument(1, 100, documentCategory, cin);
      if (response.status === 200) {
        setDocumentData(response.data.documents || []);
      } else {
        setError(response.message || "Failed to fetch documents.");
        setDocumentData([]);
      }
    } catch (err) {
      setDocumentData([]);
    } finally {
      setLoading(false);
    }
  }, [cin]);

  useEffect(() => {
    if (cin && !refreshLoading) {
      fetchDocuments(activeTab);
    }
  }, [activeTab, cin, fetchDocuments,refreshLoading]);

  const renderTableContent = () => {
    if (loading)
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <RotatingLines height="80" width="80" color="#4fa94d" ariaLabel="circles-loading" visible={true} />
        </div>
      );

    if (error) {
      return <div>{error}</div>;
    }

    switch (activeTab) {
      case "Financial":
        return <FinancialDocuments documents={documentData} isSubScribe={isSubScribe} activeTab={activeTab}/>;
      case "Charge":
        return <ChargeDocuments documents={documentData} isSubScribe={isSubScribe} activeTab={activeTab}/>;
      case "Incorporation":
        return <IncorporationandOtherDocuments documents={documentData} isSubScribe={isSubScribe} activeTab={activeTab} />;
      case "Scanned":
        return <ScannedDocuments documents={documentData} isSubScribe={isSubScribe} activeTab={activeTab}/>;
      default:
        return null;
    }
  };

  return (
    <div className={styles.structure_container}>
      <div className={styles.Compilance_container}>
        <div className={styles.finace_subcontainer}>
          <div className={styles.finac_box}>
            {financialData.map((item, index) => (
              <div
                key={index}
                className={`${styles.finac_box_text_container} ${activeTab === item.type ? styles.Active_subTab : ""}`}
                onClick={() => setActiveTab(item.type)}
              >
                <h4 className={styles.finac_box_header}>{item.title}</h4>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Render documents or no data */}
      {renderTableContent()}
    </div>
  );
}

export default SourceDocuments;
